/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box, Flex, Text, Center, Table, Thead, Tbody, Tfoot, Tr, Th, Td, Badge, Tooltip, Button } from '@chakra-ui/react';
import { faSlidersH, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useLazyQuery } from '@apollo/client';
import { useLocation, useHistory } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import ComplaintFilter from '../../components/Filter/OtherComplaintFilter';
import LoadingTable from '../../components/Table/Loading';
import datePickerFromToToDate from '../../utils/datePickerFromToToDate';
import PrintLayout from '../../components/Print/PrintLayout';
import ReactPaginate from 'react-paginate';
import useStore from '../../store';
import moment from 'moment';
import c from '../../constant';
import './style.css';

const limit = 10;
const QUERY_COMPLAINTS = gql`
  query getComplaintss(
        $offset:Float,
        $fromDate: DateTime,
        $toDate: DateTime,
        $read: Boolean,
        $spam: Boolean,
        $adminStatus: String
		$companyId: String
		$companyName: String
    ){
    getComplaints(
        pagerInput:{
            limit:${limit}
            offset:$offset
        }
        fromDate: $fromDate
        toDate: $toDate
        read: $read
        spam: $spam
        adminStatus: $adminStatus
		companyId: $companyId
		companyName: $companyName
    ){
      
      complaints{
        id
        no
        subject
        description
        createdAt
        complaintFile
        complaintFileSize
        complaintType
        settled
        settledDate
        spam
        notification{
            read
        }
        platform
        adminComplaintStatus
      }
      countUnreadComplaints
      totalPages
      totalRows

	  StatusTypes {
        countInProgress
        countWaitingForCompany
        countReceivedCompanyReply
        countProvidedReplyToApplicant
        countApplicantMadeDecision
        countSettled
        countWithdrawn
      }
    }
  }
`;

function Complaint() {
	const { t } = useTranslation();
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const currentPage = urlParams.get('page') ? urlParams.get('page') : 1;
	const { currentLang } = useStore((state) => state.currentLang);
	const fromDate = urlParams.get('fromDate') ? urlParams.get('fromDate') : null;
	const toDate = urlParams.get('toDate') ? urlParams.get('toDate') : null;
	const read = urlParams.get('read') ? urlParams.get('read') : null;
	const status = urlParams.get('status') ? urlParams.get('status') : null;
	const showSpam = urlParams.get('showSpam') ? urlParams.get('showSpam') : null;
	const companyName = urlParams.get('companyName') || null;
	const companyId = urlParams.get('companyId') || null;
	const [loadComplaints, { loading, data }] = useLazyQuery(QUERY_COMPLAINTS);

	// useEffect(() => {
	// 	if (data?.getComplaints) {
	// 		console.log('data:', data?.getComplaints);
	// 	}
	// }, [data]);

	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');

	useEffect(() => {
		window.scrollTo(0, 0);
		loadComplaints({
			variables: {
				offset: currentPage ? (currentPage - 1) * limit : 0,
				fromDate: datePickerFromToToDate(fromDate),
				toDate: datePickerFromToToDate(toDate),
				read: read === 'false' ? false : read === 'true' ? true : null,
				spam: showSpam === 'true' ? true : false,
				adminStatus: status ? status : 'all',
			},
		});
	}, []);

	const [openFilter, setOpenFilter] = useState(false);

	function handlePageClick(data) {
		let selected = data.selected;
		const page = selected + 1;

		let url = `?page=${page}`;

		if (status) {
			url += `&status=${status}`;
		}
		if (fromDate) {
			url += `&fromDate=${fromDate}`;
		}
		if (toDate) {
			url += `&toDate=${toDate}`;
		}
		if (read !== null) {
			const unreadOnly = read ? read : '';
			if (unreadOnly) {
				url += `&read=false`;
			}
		}
		if (showSpam) {
			url += `&showSpam=${showSpam}`;
		}
		if (companyName) {
			url += `&companyName=${companyName}`;
		}

		if (companyId) {
			url += `&companyId=${companyId}`;
		}
		history.push(`/complaint${url}`);
	}

	useEffect(() => {
		if (currentPage) {
			window.scrollTo(0, 0);
			loadComplaints({
				variables: {
					offset: currentPage ? (currentPage - 1) * limit : 0,
					fromDate: datePickerFromToToDate(fromDate),
					toDate: datePickerFromToToDate(toDate),
					// settled: status !== null ? (status === 'in progress' ? false : status === 'settled' ? true : null) : null,
					read: read === 'false' ? false : read === 'true' ? true : null,
					spam: showSpam === 'true' ? true : false,
					adminStatus: status ? status : 'all',
					companyId,
					companyName,
				},
			});
		}
	}, [currentPage, fromDate, toDate, read, status, showSpam, companyId, companyName]);

	function complaintType(type) {
		return type === 'COMPLAINT' ? <Badge colorScheme="purple">{t('Complaint')}</Badge> : <Badge colorScheme="green">{t('Cancel Complaint')}</Badge>;
	}

	function callbackFilter(e) {
		history.push(`/complaint${e}`);
	}

	function getStatus({ settled, settledDate }, adminComplaintStatus) {
		if (settled === true) {
			return (
				<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
					<Badge colorScheme="green">{t('Settled')}</Badge>
				</Tooltip>
			);
		} else {
			switch (adminComplaintStatus) {
				case 'IN_PROGRESS':
					return <Badge colorScheme="red">{t('In progress')}</Badge>;
				case 'WAITING_FOR_COMPANY_REPLY':
					return <Badge colorScheme="yellow">{t('Waiting for company reply')}</Badge>;
				case 'RECIEVED_COMPANY_REPLY':
					return <Badge colorScheme="teal">{t('Received company reply')}</Badge>;
				case 'PROVIDED_REPLY_LETTER_TO_APPLICANT':
					return <Badge colorScheme="purple">{t('Provided reply letter to applicant')}</Badge>;
				case 'APPLICANT_MADE_DECISION':
					return <Badge colorScheme="blue">{t('Applicant made decision')}</Badge>;
				case 'SETTLED':
					return (
						<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
							<Badge colorScheme="green">{t('Settled')}</Badge>
						</Tooltip>
					);
				case 'WITHDRAWN':
					return <Badge colorScheme="gray">{t('Withdrawn')}</Badge>;
				default:
					return '-';
			}
		}

		// return settled === true ? (
		//  <Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
		//      <Badge colorScheme="green">{t('Settled')}</Badge>
		//  </Tooltip>
		// ) : (
		//  <Badge colorScheme="yellow">{t('In progress')}</Badge>
		// );
	}

	function getPlatformbadge(platform) {
		switch (platform) {
			case 'mobile':
				return (
					<Badge ml={1} colorScheme="blue">
						{t('Mobile')}
					</Badge>
				);
			case 'web':
				return (
					<Badge ml={1} colorScheme="purple">
						{t('Website')}
					</Badge>
				);
			default:
				return (
					<>
						{/* <Badge ml={1} colorScheme="yellow">
							{t('old complaint')}
						</Badge> */}
						<Badge ml={1} colorScheme="purple">
							{t('Website')}
						</Badge>
					</>
				);
		}
	}

	function panelTabs({ name, value, shortcutLabel, statusCount }) {
		let active = status ? status : 'all';

		return (
			<Tooltip label={t(name)}>
				<Flex
					userSelect="none"
					minW="100px"
					onClick={() => {
						handleTabChange(value);
					}}
					cursor="pointer"
					mb={'-2px'}
					_hover={{ boxShadow: `inset 0 -2px 0 0 ${value === active ? '#2980b9' : '#bdc3c7'}` }}
					boxShadow={value === active ? 'inset 0 -2px 0 0 #2980b9' : ''}
					pt="16px"
					pb="16px"
					pl="12px"
					pr="12px"
					alignItems="center"
					justifyContent="center"
				>
					<Text fontSize="11px">{t(shortcutLabel)}</Text>
					{statusCount != null && statusCount > 0 && (
						<Box>
							<Badge colorScheme="red" variant="solid" ml={1}>
								{statusCount}
							</Badge>
						</Box>
					)}
				</Flex>
			</Tooltip>
		);
	}

	function handleTabChange(tabValue) {
		const page = 1;

		let url = `?page=${page}`;

		if (tabValue) {
			url += `&status=${tabValue}`;
		}

		if (fromDate) {
			url += `&fromDate=${fromDate}`;
		}
		if (toDate) {
			url += `&toDate=${toDate}`;
		}
		if (read !== null) {
			const unreadOnly = read ? read : '';
			if (unreadOnly) {
				url += `&read=false`;
			}
		}
		if (showSpam) {
			url += `&showSpam=${showSpam}`;
		}

		if (companyName) {
			url += `&companyName=${companyName}`;
		}

		if (companyId) {
			url += `&companyId=${companyId}`;
		}
		history.push(`/complaint${url}`);
	}

	const tabList = [
		{ label: 'All', value: 'all', shortcutLabel: 'All' },
		{ label: 'In progress', value: 'IN_PROGRESS', shortcutLabel: 'In progress', count: data?.getComplaints?.StatusTypes?.countInProgress },
		{
			label: 'Waiting for company reply',
			value: 'WAITING_FOR_COMPANY_REPLY',
			shortcutLabel: 'Waiting for company',
			count: data?.getComplaints?.StatusTypes?.countWaitingForCompany,
		},
		{
			label: 'Received company reply',
			value: 'RECIEVED_COMPANY_REPLY',
			shortcutLabel: 'Company replied',
			count: data?.getComplaints?.StatusTypes?.countReceivedCompanyReply,
		},
		{
			label: 'Provided reply letter to applicant',
			value: 'PROVIDED_REPLY_LETTER_TO_APPLICANT',
			shortcutLabel: 'Reply to applicant',
			count: data?.getComplaints?.StatusTypes?.countProvidedReplyToApplicant,
		},
		{
			label: 'Applicant made decision',
			value: 'APPLICANT_MADE_DECISION',
			shortcutLabel: 'Applicant replied',
			count: data?.getComplaints?.StatusTypes?.countApplicantMadeDecision,
		},
		{ label: 'Settled', value: 'SETTLED', shortcutLabel: 'Settled', count: data?.getComplaints?.StatusTypes?.countSettled },
		{ label: 'Withdrawn', value: 'WITHDRAWN', shortcutLabel: 'Withdrawn', count: data?.getComplaints?.StatusTypes?.countWithdrawn },
	];

	return (
		<>
			<PrintLayout>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'COMPLAINT',
								path: '/complaint-type',
							},
							{
								name: 'Other Complaint',
								path: '#',
							},
						]}
					/>
					<Center className="show-only-printing">
						<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
							បណ្តឹងទូទៅ
						</Text>
					</Center>
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb="32px"
						>
							<Flex
								className="hidden-print"
								bg="#FAFAFA"
								p="16px"
								pt="0"
								pb="0"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Flex pb="2px" flex="1">
									{tabList.map((item) => {
										return panelTabs({ name: item.label, value: item.value, shortcutLabel: item.shortcutLabel, statusCount: item.count });
									})}
								</Flex>
								<Flex alignItems="center">
									<Button
										mr="2"
										onClick={() => window?.print()}
										leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
										colorScheme="gray"
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
									>
										{t('Print')}
									</Button>
									<Button
										onClick={() => setOpenFilter(true)}
										leftIcon={<FontAwesomeIcon icon={faSlidersH} style={{ fontSize: 16 }} />}
										colorScheme={`${fromDate || toDate || read || showSpam || companyId || companyName ? 'yellow' : 'gray'}`}
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7}"
									>
										{t('Filter')}
									</Button>
								</Flex>
							</Flex>

							<Box p="16px">
								<Table variant="simple">
									<Thead>
										<Tr>
											<Th>{t('Number')}</Th>
											<Th>{t('Subject')}</Th>
											<Th>{t('Created At')}</Th>
											<Th>{t('Platform')}</Th>
											<Th isNumeric>{t('Status')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{loading && <LoadingTable column={5} />}
										{data?.getComplaints?.complaints.length <= 0 && (
											<Tr>
												<Td>
													<Text>{t('No Data')}</Text>
												</Td>
											</Tr>
										)}
										{data?.getComplaints?.complaints?.map((complaint, index) => {
											return (
												<Tr
													cursor="pointer"
													_hover={{ bg: 'gray.200' }}
													onClick={() => {
														complaint.adminComplaintStatus !== null
															? history.push(`/complaint/new-detail?id=${complaint.id}`)
															: history.push(`/complaint/detail?id=${complaint.id}`);
													}}
													key={`complaint-${index}`}
													bg={complaint?.notification?.read === false ? 'gray.100' : 'white'}
												>
													<Td>{complaint.no}</Td>
													<Td fontWeight="500">
														<Text maxW="400px" noOfLines={4}>
															{complaint.subject}
														</Text>
													</Td>
													<Td>{moment(complaint.createdAt).format('LLLL')}</Td>
													<Td>
														{/* {complaintType(complaint.complaintType)} */}
														{getPlatformbadge(complaint?.platform)}
													</Td>
													<Td isNumeric>
														{complaint.spam === false &&
															getStatus(
																{ settled: complaint.settled, settledDate: complaint.settledDate },
																complaint.adminComplaintStatus,
															)}
														{complaint.spam === true && <Badge colorScheme="red">{t('Spam')}</Badge>}
													</Td>
												</Tr>
											);
										})}
									</Tbody>
									<Tfoot>
										<Tr>
											<Th>{t('Number')}</Th>
											<Th>{t('Subject')}</Th>
											<Th>{t('Created At')}</Th>
											<Th>{t('Platform')}</Th>
											<Th isNumeric>{t('Status')}</Th>
										</Tr>
										<Tr>
											<Th />
											<Th />
											<Th />
											<Th />
											<Th isNumeric>
												{t('Total Rows')}: {data?.getComplaints?.totalRows}
											</Th>
										</Tr>
									</Tfoot>
								</Table>
								<Flex justifyContent="flex-end" w="100%" mt="4">
									{data?.getComplaints?.totalPages > 1 && (
										<ReactPaginate
											previousLabel={<ChevronLeftIcon fontSize="20px" />}
											nextLabel={<ChevronRightIcon fontSize="20px" />}
											breakLabel={'...'}
											breakClassName={'break-me'}
											pageCount={data?.getComplaints?.totalPages}
											marginPagesDisplayed={2}
											pageRangeDisplayed={3}
											onPageChange={handlePageClick}
											containerClassName={'pagination'}
											activeClassName={'active'}
											initialPage={(currentPage - 1) | 0}
										/>
									)}
								</Flex>
							</Box>
						</Box>
					</Center>
				</Container>
				<ComplaintFilter
					callback={callbackFilter}
					isOpen={openFilter}
					onClose={() => setOpenFilter(false)}
					fromDate={fromDate}
					toDate={toDate}
					read={read}
					status={status}
					showSpam={showSpam === 'true' ? true : false}
					companyName={companyName}
					companyId={companyId}
				/>
			</PrintLayout>
		</>
	);
}

export default Complaint;
